var MDB = window.MDB || {};;
MDB.Forms = MDB.Forms || {};
MDB.Forms.Edit = MDB.Forms.Edit || {};

var _config;

$.extend(MDB.Forms.Edit,
    {
        boot: function(config) {
            _config = config;
            MDB.Forms.Edit.initControls();
        },
        initControls: function() {
            var newForm = $('#new-form-form');
            var saveNewForm = $('#save-new-form');

            saveNewForm.click(function(e){
                e.preventDefault();

                var model = newForm.serialize();

                MDB.sendAjaxRequest(_config.editFormUrl + '?' + model, {}, 'POST').done(function(data){
                    MDB.Forms.Edit.loadForms();
                });
            });

            MDB.Forms.Edit.loadForms();
        },
        loadForms: function(){
            var forms = $('#form-list');
            forms.load(_config.formListUrl, function(){
                
                $('.edit-form-btn').each(function(){
                    var me = $(this);
                    var row = me.parent().parent();

                    me.click(function(e){
                        e.preventDefault();
                        row.find('.txt-name').show();
                        row.find('.name-txt').hide();
                        row.find('.save-form-btn').show();
                        me.hide();
                    });
                });

                $('.save-form-btn').each(function(){
                    var me = $(this);
                    var row = me.parent().parent();

                    me.click(function(e){
                        e.preventDefault();

                        var id = row.find('.form-id').val();
                        var text = row.find('.name-txt');
                        var input = row.find('.txt-name');
                        var editBtn = row.find('.edit-form-btn');

                        input.hide();
                        text.val(input.val())
                        text.show();
                        editBtn.show();
                        me.hide();

                        MDB.sendAjaxRequest(_config.editFormUrl + 
                            '?Id=' + encodeURIComponent(id) + 
                            "&name=" +  encodeURIComponent(input.val()), {}, 'POST').done(function(data){
                            MDB.Forms.Edit.loadForms();
                        });
                    });
                });

                $('.delete-form-btn').each(function(){
                    var me = $(this);
                    var row = me.parent().parent();

                    me.click(function(e){
                        e.preventDefault();

                        var id = row.find('.form-id').val();
                        var name = row.find('.name-txt').text();

                        MDB.promptHtml('Are you sure?', '<i class="fa fa-trash-o text-danger" style="font-size:large"></i>&nbsp;' +
                            'Are you sure you want to delete this form?', function(ok){
                            if(ok){
                                MDB.sendAjaxRequest(_config.editFormUrl + 
                                '?Id=' + encodeURIComponent(id) + 
                                "&Name=" +  encodeURIComponent(name) +
                                "&IsDeleted=true", {}, 'POST').done(function(data){
                                    MDB.Forms.Edit.loadForms();
                                });
                            }
                        });
                    });
                });

                $('.edit-pages-btn').each(function(){
                    var me = $(this);
                    var row = me.parent().parent();
                    var id = row.find('.form-id').val();


                });
            });
        },        
        // getPages: function(id) {
        //     $('#pages-editor').show();
        //     return false;
        // }
    });